<template >
    <Navigation
        class="d-flex"
        :navigationItemList="modelsItems"
        :data="data"
        @selectNavigationItem="setActiveItem"
        @selectNavigationItemMenu="setActiveSubItem"
    />
</template>

<script>
    import { EventBus } from '@/event-bus';
    import Navigation from '@/layout/alternative/layout/components/Navigation.vue';

    export default {
        name: "ModelsBody",
        props: {
            data: {
                type: Object,
                required: true
            }
        },
        components:{
            Navigation,
        },
        computed:{
            modelsItems() {
                return this.$props.data ? this.$props.data.items : {};
            }
        },
        methods: {
            setActiveItem(currentItem) {
                if (!currentItem.active) {
                    if (!currentItem.submenu) {
                        this.$props.data.items.forEach(item => item.active = false);
                        this.setActive(currentItem);
                    }  
                }
            },
            setActiveSubItem(subItem) {
                if (!subItem.active) {
                    this.$props.data.items.forEach(el => el.active = false);
                    this.setActive(subItem);
                }
            },
            setActive(currentItem) {
                if (!currentItem.active) {
                    this.$props.data.items.forEach(item => {
                        if (item.submenu) {
                            item.submenu.forEach(subitem => {
                                subitem.active = currentItem.link === subitem.link;
                                if (subitem.active) 
                                    item.active = true;
                            });
                        }
                        else
                            item.active = currentItem.link === item.link;
                    });
                    if (currentItem.link) {
                        EventBus.$emit('updateLoadedWidgets', {
                            id: currentItem.id,
                            link: currentItem.link,
                            active: true,
                            widgetType: currentItem.id
                        });
                    }
                }
            },  
        }
    }
</script>


// WEBPACK FOOTER //
// src/layout/alternative/models/ModelsBody.vue